// Toyo New configuration
import { AppConfig } from './types';
import { newTheme } from './themes';
import { NEW_GAMES } from './games';

export const newConfig: AppConfig = {
  appId: 'new',
  appName: 'Toyo New',
  appTagline: 'Fresh games. Same rooms.',

  theme: newTheme,

  games: [...NEW_GAMES],

  features: {
    voting: true,
    hostPlaying: true,
    settings: true,
  },

  storagePrefix: 'toyo-new',

  seo: {
    title: 'Toyo New - Fresh Party Games | new.toyo.games',
    description:
      'New Toyo party games in the same rooms you know. Drawing, bluffing, deduction, and more — playtested here before they land in other packs.',
    keywords: [
      'toyo new',
      'new.toyo.games',
      'party games',
      'doodle heist',
      'multiplayer drawing',
      'bluffing games',
      'tv party games',
    ],
    ogTitle: 'Toyo New - Fresh games. Same rooms.',
    ogDescription: 'Drawing, bluffing, and more — new Toyo games with real rooms and reconnection.',
    ogImage: '/assets/logo.png',
    ogUrl: 'https://new.toyo.games',
    twitterCard: 'summary_large_image',
    twitterTitle: 'Toyo New - Fresh games. Same rooms.',
    twitterDescription: 'New Toyo party games with real rooms and reconnection.',
    twitterImage: '/assets/logo.png',
  },
};
